if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('.product-form__submit-label');

        if (document.querySelector('cart-notification') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.requiresFinalSaleAck = this.dataset.requiresFinalSaleAck === 'true';
        this.variantUnavailable = this.submitButton?.dataset.variantDisabled === 'true';

        if (this.requiresFinalSaleAck) {
          this.finalSaleCheckbox = document.getElementById(`FinalSaleAck-${this.dataset.sectionId}`);
          this.finalSaleCheckbox?.addEventListener('click', (event) => event.stopPropagation());
          this.finalSaleCheckbox?.addEventListener('change', () => this.applySubmitButtonState());
          this.applySubmitButtonState();
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.requiresFinalSaleAck && !this.finalSaleCheckbox?.checked) {
          this.promptFinalSaleAcknowledgement();
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        if (
          this.dataset.skipSizeSelection !== 'true' &&
          window.ProductSizeSelection?.hasSizeOption(this.dataset.sectionId) &&
          !window.ProductSizeSelection?.isSizeSelected(this.dataset.sectionId)
        ) {
          window.ProductSizeSelection.promptSizeSelection(this.dataset.sectionId);
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.setAttribute('aria-busy', 'true');
        this.submitButton.classList.add('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            const styleWithQuickAdd = this.closest('.style-with-quick-add');
            if (styleWithQuickAdd) {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
              styleWithQuickAdd.close();
            } else if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-busy');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      promptFinalSaleAcknowledgement() {
        const target = this.finalSaleCheckbox?.closest('.final-sale-acknowledgement');
        if (!target) return;

        const rect = target.getBoundingClientRect();
        const inView = rect.top >= 0 && rect.bottom <= window.innerHeight;
        if (!inView) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        target.classList.remove('is-shaking');
        void target.offsetWidth;
        target.classList.add('is-shaking');
        target.addEventListener(
          'animationend',
          () => target.classList.remove('is-shaking'),
          { once: true }
        );
        this.finalSaleCheckbox?.focus();
      }

      applySubmitButtonState(text) {
        const finalSaleBlocked = this.requiresFinalSaleAck && !this.finalSaleCheckbox?.checked;

        this.submitButton.toggleAttribute('data-final-sale-blocked', finalSaleBlocked);

        if (this.variantUnavailable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (text) this.submitButtonText.textContent = text;
        }
      }

      toggleSubmitButton(disable = true, text) {
        this.variantUnavailable = disable;
        this.submitButton.dataset.variantDisabled = disable ? 'true' : 'false';

        if (!disable && !text) {
          text = window.variantStrings.addToCart;
        }

        this.applySubmitButtonState(text);
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
